import { IFsMap } from '../types';

export abstract class FsMapServiceProvider<TMap extends IFsMap> {
  // IFsMap methods and properties
  abstract readonly geospatialProvider: string;
  abstract readonly id: string;
  abstract getZoom(): number;
  abstract setZoom(zoom: number): void;
  abstract getCenter(): any;
  abstract setCenter(coords: any): void;
  abstract getBounds(): any;
  abstract setStyle(style: string): void;
  abstract getStyle(): string;
  abstract setOptions(options: any): void;
  abstract panTo(coords: any): void;
  abstract setHeading(heading: number): void;
  abstract on(event: string): any;
  abstract addMarker(marker: any): void;
  abstract removeMarker(marker: any): void;
  abstract addLayer(layer: any): void;
  abstract removeLayer(layer: any): void;
  abstract setMapId(mapId: string): void;
  abstract removeLayers(): void;

  // Facade-specific methods
  abstract get isRoomClearingEnabled(): boolean;
  abstract get activePopoutCount(): number;
  abstract get axonDeviceMarkers(): any[];
  abstract setAlertBoundaryStatus(status: string): void;
  abstract placeMarker(coords: { lng: number; lat: number }): void;
  abstract onLoaded(fsMap: TMap): void;
  abstract goTo(type: string, target: any, action?: string): void;
  abstract goToCoordinates(coords: { lng: number; lat: number }, zoom?: number): void;
  abstract activateLocation(locationId: string, move?: boolean, keepAlarmPopup?: boolean): void;
  abstract deactivateLocation(): void;
  abstract zoomIn(): void;
  abstract zoomOut(): void;
  abstract slewTo(coords: { lng: number; lat: number }): void;
  abstract isLayerSelected(type: string): boolean;
  abstract toggleInnerLayer(type: string): void;
  abstract addShape(type: string, action: string, source: string): void;
  abstract setDrawingMode(overlayType?: any): void;
  abstract isModeActive(mode: string, source: string): boolean;
  abstract setCamerasParams(params: any): void;
  abstract setLprMakesParams(params: any, isLayerOn?: boolean): void;
  abstract toggleRoomClearing(): void;
  abstract removeAllCadPopouts(): void;
  abstract manageAlertBoundary(): void;
  abstract closedAlarmListener(alarm: any): void;
}
